import React from 'react';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { LuRefreshCcw } from 'react-icons/lu';
import { FaRegEye } from 'react-icons/fa';
import { getTimeAgo } from '../../../_helpers/getTimeAgo';

const RedeemRequestMerchantCard = ({
  kycAddressDoc = "/img/image.png",
  accountName = "Huzaifa Khan",
  accountNumber = "4242424242424242",
  ifscCode,
  bankName = "YES BANK",
  accountType = "Savings",
  branch = "Jaipur",
  accountCurrency = "INR",
  swiftCode,
  iban = "sp16ct200698741557",
  bankAddress = "C- Scheme Jaipur",
  statusTitle,
  handleApprove,
  handleReject,
  handleMoreInfo,
  verifiedBy, id,
  handleAction, date,
  storeName,
  storLogo,
  storeURL,
  storeStatus, userName,
  userEmail
}) => {


  console.log(statusTitle)


  const renderIconsAndText = () => {
    switch (statusTitle) {
      case 'Pending':
        return (
          <div className="flex gap-1">
            <div className="flex items-center justify-center w-5 h-5">
              <button className='cursor-pointer' onClick={handleReject}>
                <AiOutlineCloseCircle className="text-[22px] text-[#F6465D]" title='Reject' />
              </button>
            </div>
            <div className="flex items-center justify-center w-5 h-5">
              <button onClick={handleApprove}>
                <IoMdCheckmarkCircleOutline className="text-[22px] text-[#02BC7D]" title='Approve' />
              </button>
            </div>
            <div className="flex items-center justify-center w-5 h-5">
              <button onClick={handleMoreInfo}>
                <LuRefreshCcw className="text-[22px] text-[#FFA600]" title='More-Info' />
              </button>
            </div>
          </div>
        );
      case 'Approved':
        return (
          <div>
            <span className="text-md font-[500] text-[#F6465D]">
              By {`(${verifiedBy?.userName} , ${verifiedBy?.employeeId} )`}
            </span>
          </div>
        );
      case 'Declined':
        return (
          <div>
            <span className="text-md font-[500] text-[#F6465D]">By {`(${verifiedBy?.userName} , ${verifiedBy?.employeeId} )`}</span>
          </div>
        );
      case 'More Info Required':
        return (
          <div>
            <span className="text-md font-[500] text-[#F6465D]">By {`(${verifiedBy?.userName} , ${verifiedBy?.employeeId} )`}</span>
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between p-4 border border-[#D2D2D2] rounded-xl gap-2 sm:gap-0">
        <div className="flex items-center flex-wrap gap-2">
          <span className="font-medium text-[#F6465D] text-sm sm:text-base">
            {statusTitle}
          </span>
          <div className="flex items-center gap-1">
            {renderIconsAndText()}
          </div>
          <button
            onClick={() => handleAction(id)}
            className="ml-auto sm:ml-2"
          >
            <FaRegEye className="text-[20px] sm:text-[22px] text-blue-500" title="View" />
          </button>
        </div>
        <span className="text-xs sm:text-sm text-[#F6465D] font-medium sm:self-center">
          {getTimeAgo(date)}
        </span>
      </div>
      <div className="flex flex-col w-full mx-auto overflow-hidden border border-gray-200 rounded-lg shadow-sm md:flex-row">
        <div className="w-full p-4 bg-white border-b border-gray-200 md:border-b-0 md:border-r">
          <div className="space-y-3">

            <div>
              <img src={storLogo} alt={storeName} className='w-[28rem] h-[18rem] mx-auto object-center' />
            </div>
            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">User Name :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{userName}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">User Email :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{userEmail}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Store Name :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{storeName}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Store URL :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{storeURL}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Store Status :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{storeStatus}</span>
            </div>



          </div>
        </div>
        <div className="w-full p-4 bg-white border-b border-gray-200 md:border-b-0 md:border-r">
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Account Name :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{accountName}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Account Number :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{accountNumber}</span>
            </div>
            {
              ifscCode && (
                <div className="flex justify-between">
                  <span className="text-[#0F172AB2] font-[500] text-[14px]">IFSC Code :</span>
                  <span className="text-[#0F172AB2] font-[500] text-[14px]">{ifscCode}</span>
                </div>
              )
            }

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Bank Name :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{bankName}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Account Type :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{accountType}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Branch :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{branch}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Account Currency :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{accountCurrency}</span>
            </div>

            {
              swiftCode && (
                <div className="flex justify-between">
                  <span className="text-[#0F172AB2] font-[500] text-[14px]">Swift code :</span>
                  <span className="text-[#0F172AB2] font-[500] text-[14px]">{swiftCode}</span>
                </div>

              )
            }



            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">IBAN :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{iban}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Bank Address :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{bankAddress}</span>
            </div>
          </div>
        </div>
        <div className="w-full p-4 bg-gray-50">
          <div className="h-full">
            <h2 className="mb-4 text-[18px] font-[500] text-[#1D1F2C]">Bank Statement / Maintenance Letter</h2>
            <div className="p-1 bg-white">
              <img
                src={kycAddressDoc}
                alt='doc1'
                className='border-2 border-[#00811D] rounded-lg w-[28rem] h-[18rem]'
                onError={(e) => e.target.src = '/img/Group 1597881797.png'}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RedeemRequestMerchantCard;